<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let text: string;
  export let size: number = 16;
  export let horizontalAlignment: "center" | "left" | "right" = "center";

</script>

<span class="fizz-tooltip-container">
  <button class="fizz-tooltip-trigger ">
    <span id="tooltip-target" tabIndex={0}>
      <Icon type="Info" height={size} width={size} color="black" />
    </span>
  </button>
  <span
    class="fizz-tooltip fizz-tooltip-top fizz-tooltip-{horizontalAlignment}"
    style="z-index: 99999"
    role="tooltip"
  >
    {text}
  </span>
</span>
